import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AddCreditTripComponent } from "../add-credit-trip/add-credit-trip.component";
import { EditCreditTripComponent } from "../edit-credit-trip/edit-credit-trip.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-delivery-orders",
  templateUrl: "./delivery-orders.component.html",
  styleUrls: ["./delivery-orders.component.css"],
})
export class DeliveryOrdersComponent implements OnInit {
  token: any;
  deliverOrderType: any = -1;
  deliverOrderArray: any = [];
  Matdialogref!: MatDialogRef<AddCreditTripComponent>;
  editDialogref: MatDialogRef<EditCreditTripComponent>;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  deliveryArray: any = [];
  search_query: any = -1;
  Workorder: any;
  loading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  @ViewChild("newItem") newItem!: ElementRef;
  constructor(
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    let triptype = "deliveryOrders";
    sessionStorage.setItem("tripType", triptype);
    this.getDeliveryOrder(
      this.deliverOrderType,
      this.search_query || -1,
      this.startPage
    );
    this.pagination(1);
  }

  getTripsList(selectedDeliveryOrder: any) {
    this.deliverOrderType = selectedDeliveryOrder;

    if (this.deliverOrderType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
      this.document_array = [];
    } else if (this.deliverOrderType == "present_work_order") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
      this.document_array = [];
    } else if (this.deliverOrderType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
      this.document_array = [];
    } else if (this.deliverOrderType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
      this.document_array = [];
    }
  }
  addCreditTrip(item: any) {
    this.Matdialogref = this.matDialog.open(AddCreditTripComponent, {
      width: "60vw",
      height: "75vh",
      data: item,
      autoFocus: false,
    });
    this.Matdialogref.afterClosed().subscribe((x) => {
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
    });
  }

  editCreditTrip(item: any) {
    this.editDialogref = this.matDialog.open(EditCreditTripComponent, {
      width: "60vw",
      height: "75vh",
      data: item,
      autoFocus: false,
    });
  }

  search(value: any) {
    if (value != "") {
      this.search_btn = false;
      this.clear_btn = true;
      this.search_query = value;
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_btn = false;
    this.search_query = -1;
    this.getDeliveryOrder(
      this.deliverOrderType,
      this.search_query || -1,
      this.startPage
    );
  }

  getDeliveryOrder(selectedDeliveryOrder: any, search: any, page: any) {
    this.search_query = search;
    this.loading = true;
    this.services
      .deliveryOrderGet(
        this.token,
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          this.deliveryArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.deliveryArray = [];
          if (error.status == 404) {
            return;
          }
          if (error.status != 404) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.currentPage) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.getDeliveryOrder(
      this.deliverOrderType,
      this.search_query || -1,
      this.startPage
    );
  }
  searchWo(event: any) {
    if (event.target.value == "") {
      this.getDeliveryOrder(
        this.deliverOrderType,
        this.search_query || -1,
        this.startPage
      );
    }
  }
}
